import { constant, Decoder, union } from '@mojotech/json-type-validation'

import { PolicyType } from '@/domain/value_objects/config/policyType'

export const policyTypeDecoder: Decoder<PolicyType> = union(constant('public'), constant('private'))
